import { render, staticRenderFns } from "./HorseBets.vue?vue&type=template&id=b45a1028&scoped=true&"
import script from "./HorseBets.vue?vue&type=script&lang=js&"
export * from "./HorseBets.vue?vue&type=script&lang=js&"
import style0 from "./HorseBets.vue?vue&type=style&index=0&id=b45a1028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a1028",
  null
  
)

component.options.__file = "HorseBets.vue"
export default component.exports